export default __webpack_public_path__ + "static/media/1877.8b1ed7a5.png";